// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8021":"378b3485","9246":"5402d6de"}[chunkId] + ".chunk.css";
};